import { render, staticRenderFns } from "./SuccessBox.vue?vue&type=template&id=b38e811e&scoped=true"
import script from "./SuccessBox.vue?vue&type=script&lang=js"
export * from "./SuccessBox.vue?vue&type=script&lang=js"
import style0 from "./SuccessBox.vue?vue&type=style&index=0&id=b38e811e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38e811e",
  null
  
)

export default component.exports